import Button from "core/buttons/button/Button";
import "./Modal.scss";
import { FormattedMessage, useIntl } from "react-intl";
import { Typography } from "core/typography/Typography";
import InputText from "core/inputs/input-text/InputText";
import InputSelect from "core/inputs/input-select/InputSelect";
import { useContext, useEffect, useState } from "react";
import { LANG, PROSPECTION_DEFAULT_COLORS } from "constants/constants";
import InfoContext from "pages/InfoContext";
import ReactDom from "react-dom";

const UpdateProspectionModal = ({
  onClose,
  sectorList,
  prospectionData,
  open,
  updateProspectionSector,
  updateProspectionTrafficLight,
  connectedUser,
}) => {
  const { lang } = useContext(InfoContext);

  const [sector, setSector] = useState("");
  const [clientName, setClientName] = useState("");
  const [trafficColor, setTrafficColor] = useState("");
  const [defaultTrafficColor, setDefaultTrafficColor] = useState("");
  const [defaultSector, setDefaultSector] = useState("");

  useEffect(() => {
    if (!prospectionData) return;
    const foundSector = sectorList?.find(
      (sector) => sector.id === prospectionData.sector_id
    );
    if (foundSector) {
      setSector(foundSector.id);
    }
    setDefaultSector(prospectionData.sector_id);
    setDefaultTrafficColor(prospectionData.color_light);
    setClientName(prospectionData?.name);
    setTrafficColor(prospectionData?.color_light);
  }, [prospectionData, sectorList, lang]);

  const onSubmit = () => {
    if (sector !== defaultSector) {
      updateProspectionSector({
        id: prospectionData.id,
        sector_id: sector,
        manager_id: connectedUser?.id,
      });
    }

    if (trafficColor !== defaultTrafficColor) {
      updateProspectionTrafficLight({
        id: prospectionData.id,
        traffic_light_value: trafficColor,
        manager_id: connectedUser?.id,
      });
    }
    onClose();
  };

  if (!open) return null;

  return ReactDom.createPortal(
    <>
      <div className="overlay-style" />
      <div className="tool-modal-style new-prospection-modal">
        <div className="header">
          <Typography
            className="title-3 violet text-uppercase"
            type="h2"
            label={
              <FormattedMessage
                id="prospection_update"
                defaultMessage="Nouvelle prospection"
              />
            }
          />
        </div>
        <div className="body">
          <div className="new_prospection_cells">
            <div className="line-1">
              <div className={`cell-padding`}>
                <InputSelect
                  overflow={"auto"}
                  label={{
                    id: "input_sector_label",
                    defaultMessage: "Secteur",
                  }}
                  id="sector-title-filter"
                  setValue={(name, e) => {
                    setSector(e);
                  }}
                  value={sector}
                  options={sectorList?.map((elm) => ({
                    label: lang === LANG.EN ? elm?.en : elm?.fr,
                    value: elm?.id,
                  }))}
                />
              </div>
              <div className={`cell-padding`}>
                <InputText
                  label={{
                    id: "filter_clients_tools_title",
                    defaultMessage: "Nom du client",
                  }}
                  value={clientName}
                  readOnly
                  id="client-title-filter"
                />
              </div>
            </div>
            <div className="line-2">
              <div className={`cell-padding`}>
                <InputSelect
                  errors={{}}
                  label={{
                    id: "input_default_color_label",
                    defaultMessage: "Couleur par défaut",
                  }}
                  id="default-color-title-filter"
                  options={PROSPECTION_DEFAULT_COLORS}
                  value={trafficColor}
                  setValue={(name, e) => {
                    setTrafficColor(e);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="new-prospection-modal-buttons">
            <Typography
              onClick={onClose}
              className={"cancel-button text violet"}
              type={"h2"}
              label={
                <FormattedMessage id={"cancel"} defaultMessage={"Annuler"} />
              }
            />
            <Button
              className="add-button btn-hover-color"
              size="medium"
              color="blue"
              type="submit"
              onClick={() => onSubmit()}
            >
              <FormattedMessage id={"validate"} defaultMessage={"Valider"} />
            </Button>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("portal")
  );
};

export default UpdateProspectionModal;
